import React, { useEffect, useState } from 'react'
import { View, StyleSheet, Text } from 'react-native'
import { PromptSuccessIcon } from '../../../../assets/icons'
import Loading from '../../../Loading'
import Wrapper from '../../Wrapper'
import { ToolbarRight } from './InvoiceReceipt'
import ReceiptStore from './ReceiptStore'
import { BtButton } from '@linqpal/components/src/ui'
import { isWeb } from '../../../../utils/helpers/commonUtils'
import cookies from '../../../../utils/service/cooker'
import { useStore } from '../../../../store'
import BuilderInvoiceSignup from '../BuilderInvoiceSignup'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'
import { Spacer } from '../../../../ui/atoms'
import { dispatcher, pathFactory } from '../../../links'
import SignInStore from '../../../Auth/stores/SignInStore'
import SignupStore from '../../../Auth/stores/SignupStore'
import useRecaptcha from '../../../Auth/useRecaptcha'
import { PaymentDetails } from './PaymentDetails'

// When supplier collects the payment on an invoice himself

const HeaderMessage = ({ t }) => {
  return (
    <View style={styles.messageView}>
      <PromptSuccessIcon style={{ width: 78, height: 78 }} />
      <Text style={styles.messageText}>
        {t('InvoiceReceipt.payment-collected-by-supplier')}
      </Text>
    </View>
  )
}

export const PaymentCollectedReceipt = observer(({ route, navigation }) => {
  const { id } = route.params
  const { t } = useTranslation('global')
  const { getInvoice, loading, invoice } = ReceiptStore
  const { userStore } = useStore()
  const isUserAuthenticated = isWeb
    ? !!cookies.get('session')
    : userStore.isAuthenticated
  const [onLoginSignup, setOnLoginSignup] = useState<boolean>(false)
  const recaptcha = useRecaptcha('signin')
  const exists = !!invoice?.existingCustomer

  useEffect(() => {
    if (exists) {
      recaptcha.createVerifier()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [SignInStore.showVerifyPage, invoice])

  useEffect(() => {
    getInvoice(id)
  }, [id, getInvoice])

  useEffect(() => {
    if (isUserAuthenticated && invoice) {
      const action = dispatcher(pathFactory('Console.InvoicesToPay.Receipt'), {
        id: invoice._id,
      })
      navigation.navigate(action.name, action.params)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLoginSignup])

  const onClose = () => {
    setOnLoginSignup(false)
  }

  const onLoginOrSignup = () => {
    if (!exists) {
      SignupStore.setUpInvoiceLinkSignup({
        ...invoice?.customer,
        invoiceId: invoice._id,
      })
    }
    SignInStore.setLogin(invoice.existingCustomer?.login)
    if (SignInStore.isValidPhone && !isUserAuthenticated) {
      SignInStore.removeError('verify')
      SignInStore.signIn(recaptcha.verifier)
    } else if (SignInStore.isValidEmail && !isUserAuthenticated) {
      SignInStore.setCanAskPassword(true)
    }
    setOnLoginSignup(true)
  }

  if (!invoice || loading) {
    return <Loading />
  }

  return (
    <Wrapper
      containerStyle={{ width: '100%', alignItems: 'center', height: '100%' }}
    >
      <HeaderMessage t={t} />
      <View style={styles.headerView}>
        <Text style={{ fontSize: 16, fontWeight: '600' }}>
          {t('InvoiceReceipt.payment_details')}{' '}
        </Text>
        <ToolbarRight invoice={invoice} />
      </View>
      <View
        style={{
          borderBottomColor: '#E6EBEE',
          borderBottomWidth: 1,
          marginBottom: 16,
        }}
      />
      <PaymentDetails showCollectedLabel={false} />
      <Spacer height={11} />
      {!isUserAuthenticated && (
        <BtButton onPress={onLoginOrSignup}>
          {invoice.existingCustomer
            ? t('InvoiceReceipt.login')
            : t('InvoiceReceipt.signup')}
        </BtButton>
      )}
      <BuilderInvoiceSignup
        invoice={invoice}
        visible={
          onLoginSignup &&
          (SignInStore.showVerifyPage || (!exists && SignupStore.isValidLogin))
        }
        navigation={navigation}
        route={route}
        onClose={onClose}
      />
    </Wrapper>
  )
})

const styles = StyleSheet.create({
  messageView: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  messageText: {
    fontWeight: '600',
    fontSize: 16,
    lineHeight: 24,
    width: 258,
    textAlign: 'center',
    marginBottom: 21,
  },
  headerView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingRight: 16,
    alignItems: 'center',
    marginBottom: 10,
    marginTop: 29,
  },
  linkStyle: {
    marginTop: 20,
  },
  linkTextStyle: {
    fontSize: 14,
    fontWeight: '600',
  },
})
